import { AnimatePresence } from "framer-motion";

import { KitchenMenuDialog } from "./KitchenMenuDialog";
import { KitchenProductSelectorDialog } from "./KitchenProductSelectorDialog";
import { ActionKind } from "../../types/Action";
import { FadeIn, SlideUp } from "../Animations";
import { CartErrorDialog } from "../CartErrorDialog";
import { SpinnerOverlay } from "../Spinner";
import {
    RootStateKind,
    ScanSubStateKind,
    useRootState
} from "../state/StateProvider";
import { useDelayedCondition } from "../useDelayedCondition";

export const Kitchen = () => {
    const { state, dispatch } = useRootState(RootStateKind.Scan);

    if (!state.kitchen.hasKitchen || !state.kitchen.menu) {
        throw new Error(
            "Tried rendering Kitchen component without valid menu."
        );
    }

    const isLoading =
        state.subState.kind === ScanSubStateKind.Kitchen &&
        state.subState.subState.kind === "loading";
    const displayLoadingIndicator = useDelayedCondition(isLoading, 2000);

    return (
        <AnimatePresence>
            {state.subState.kind === ScanSubStateKind.Kitchen && (
                <div data-theme="kitchen">
                    <FadeIn className="pt-30 fixed inset-0 bg-primary-900 bg-opacity-75" />
                    <SlideUp
                        key="select"
                        className={`fixed inset-x-0 bottom-0 ${
                            state.accessibilityMode ? "top-80" : "top-0"
                        } z-10 rounded-t-xl`}
                    >
                        {displayLoadingIndicator && <SpinnerOverlay />}
                        {state.subState.subState.kind === "error" && (
                            <CartErrorDialog
                                error={state.subState.subState.reason}
                                onOk={() =>
                                    dispatch({
                                        kind: ActionKind.HideCartErrorDialog
                                    })
                                }
                            />
                        )}
                        <KitchenMenuDialog
                            cartQuantity={state.cart.positions.length}
                            cartGrossPrice={state.cart.grossPrice}
                            cartTotalPrice={state.cart.totalPrice}
                            kitchenMenu={state.kitchen.menu}
                            onCancel={() =>
                                dispatch({ kind: ActionKind.HideKitchenMenu })
                            }
                        />

                        {state.subState.subState.kind === "productSelector" && (
                            <KitchenProductSelectorDialog
                                product={state.subState.subState.product}
                                onConfirm={(
                                    productId,
                                    barcode,
                                    quantity,
                                    addOnOptionIds,
                                    comboBarcodes,
                                    upsellingProductBarcodes
                                ) => {
                                    dispatch({
                                        kind: ActionKind.AddKitchenProduct,
                                        productId,
                                        barcode,
                                        quantity,
                                        addOnOptionIds,
                                        comboBarcodes,
                                        upsellingProductBarcodes
                                    });
                                }}
                                onCancel={() =>
                                    dispatch({
                                        kind: ActionKind.HideKitchenProductSelector
                                    })
                                }
                            />
                        )}
                    </SlideUp>
                </div>
            )}
        </AnimatePresence>
    );
};
